<template>
  <div>
      <main-header></main-header>
      <div class="registermain">
          <div class="w1200 registerbg">
              <h1>{{language[languagetype].title}}</h1>
              <div class="cont">
                <i></i>
                <span>{{language[languagetype].desc}}</span>
              </div>
              <div class="back">
                <div @click="toindex">{{language[languagetype].back}}</div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import MainHeader from './header'
let languagetext = require('../js/succful.json')
export default {
  name: 'index',
  data () {
    return {
      language: {},
      languagetype: 'cn'
    }
  },
  methods: {
    toindex: function () {
      this.$router.push({name: 'index'})
    }
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
  },
  components: {
    MainHeader
  },
  beforeCreate () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.registermain{min-height: 683px;background-color: #F6F6F6;overflow: hidden;}
.registerbg{height: 580px;margin-top: 50px;background-color: #Fff;}
.registerbg h1{width: 100%;height: 0.6rem;line-height: 0.6rem;margin-top: 80px;color: #333333;font-size: 30px;text-align: center;}
.registerbg .cont{width: 100%;height: 102px;margin-top: 100px;}
.registerbg .cont i{display: block;width: 48px;height: 48px;background:url("../assets/dui.png") center center no-repeat;margin: 0 auto;}
.registerbg .cont span{display: block;width: 100%;height: 35px;line-height: 35px;text-align: center;font-size: 16px;}
.registerbg .back{width: 100%;height: 50px;margin-top: 158px;}
.registerbg .back div{width: 310px;height: 50px;background-color: #1c5cef;color: #fff;text-align: center;line-height: 50px;margin: 0 auto;font-size: 20px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/page/succful.vue